export const USER_STATUS = {
  NEW: "NEW",
  MEMBER: "MEMBER",
  BANNED: "BANNED",
}
